import React, { useState } from "react";
import tempIcon from "../../../assets/icons/temp.webp";
import waterIcon from "../../../assets/icons/windDrop.webp";
import sunIcon from "../../../assets/icons/sun.webp";
import phIcon from "../../../assets/icons/ph.webp";
//import Refresh from "../../../assets/icons/Refresh";
//import ControlSlider from "../../../components/panel/ControlSlider";

const properties = {
  temperature: {
    icon: tempIcon,
    label: "°C",
    title: "Temperatura",
  },
  humidity: {
    icon: waterIcon,
    label: "%",
    title: "Humedad",
  },
  light: {
    icon: sunIcon,
    label: "lm",
    title: "Luz",
  },
  ph: {
    icon: phIcon,
    label: "",
    title: "Ph",
  },
};

const ControlCard = ({ obj, showPopUp }) => {
  //============SCROLL VARIABLES============
  const [scrollPos, setScrollPos] = useState(0);

  const changeScrollPos = (pos) => {
    setScrollPos(pos);
  };

  //========================================

  return (
    <div className="flex flex-col font-poppins  items-center bg-white justify-center border-[1px] border-accent-green rounded-[10px] shadow-md py-6 md:m-4 m-1 min-w-[300px]">
      <div className="flex items-center justify-center py-4">
        <img
          src={properties[obj.property].icon}
          className="max-w-[70px] w-full"
        />
      </div>
      <h2 className="text-xl font-bold text-dark-green">
        {properties[obj.property].title}
      </h2>
      <h1 className="text-6xl font-bold text-dark-green">
        {obj.data.length > 0 ? obj.data[obj.data.length - 1].value : "--"}
        {properties[obj.property].label != "" && (
          <span className="ml-2 text-4xl font-regular">
            {properties[obj.property].label}
          </span>
        )}
      </h1>
      {/* <ControlSlider
        className="w-full "
        scrollPos={scrollPos}
        setScrollPos={changeScrollPos}
        showPopUp={showPopUp}
      /> */}
    </div>
  );
};

export default ControlCard;
